export const LOGO_URL = "https://static.vecteezy.com/system/resources/thumbnails/056/435/207/small/chef-mascot-logo-design-for-restaurant-cooking-man-yummy-express-food-illustration-vector.jpg";

